module.exports = __webpack_public_path__ + "static/img/laboratory1.851a936.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/laboratory1.jpg
// module id = T9m0
// module chunks = 1